module.exports = __webpack_public_path__ + "img/vesparza.01469f74.jpg";